module.exports = __webpack_public_path__ + "img/addproperty.e8e0785.png";